export { ReactComponent as TextAlignRight } from './svgs/align-text-right.svg';
